module.exports = __webpack_public_path__ + "img/image30.1d5b8ac6.png";